/**
 * The brand a console page wears, from the host it was opened on (ADR-69
 * section 13). console.lotnumber.com serves the SAME artifact as
 * console.hipnum.com; the hand-written .html ships the HipNumber words, and on
 * a LotNumber host this renames the two places a staffer sees the brand: the
 * tab title and the header mark's word (the orange "24" tag is kept, the way
 * the storefront's LotNumber shell draws it). Presentation only: the session,
 * the API (one API behind both doors) and every sale's own product are the
 * same, and a HipNumber host is left exactly as shipped.
 *
 * Not renamed: the printed checkout receipt and the bidder-facing screens
 * (tv, display, b), which do not run initTheme. Those belong to the sale, and
 * the sale's product, not the door, should decide their brand.
 */

import { SHELLS, shellForHost } from '@hipnumber/products';

export function applyHostBrand(doc: Document = document, hostname: string = location.hostname): void {
  const from = SHELLS.hipnumber;
  const to = SHELLS[shellForHost(hostname)];
  if (to === from) return;
  doc.title = doc.title.replace(from.name, to.name);
  for (const svg of Array.from(doc.querySelectorAll('svg.brand-logo'))) {
    svg.setAttribute('aria-label', to.name);
    for (const text of Array.from(svg.querySelectorAll('text'))) {
      if (text.textContent === from.markWord) text.textContent = to.markWord;
    }
  }
}
